import script from "./TabList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabList.vue?vue&type=script&setup=true&lang=ts"

import "./TabList.vue?vue&type=style&index=0&id=643ba093&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643ba093"]])

export default __exports__